import AddProductCategory from './AddProductCategoryView';

export default AddProductCategory;